<template>
	<div
		v-if="
			(Boolean(route.query.isMoreMenuOpen) ||
				Boolean(route.query.isSearchMenuOpen || Boolean(route.query.isNotificationMenuOpen)) ||
				Boolean(route.query.isCountryMenuOpen) ||
				Boolean(route.query.isInterestMenuOpen)) &&
			displayStore.isDesktop
		"
		class="dimmed"
	></div>
	<header
		id="TopHeader"
		class="TopHeader"
		:class="{
			transparent: path === '/',
			open: Boolean(route.query.isMoreMenuOpen) && displayStore.isDesktop,
			scrolled: isScrolled,
			downScroll: isDownScroll,
			stickyTab: stickyTab,
		}"
	>
		<!-- 데스크탑용 헤더 -->
		<div v-if="displayStore.isDesktop && !stickyTab" class="desktopHeader">
			<div class="c_inner">
				<div class="menuList">
					<div class="logoMenu">
						<router-link to="/" class="logo">
							<img src="@/assets/img/bi/bi.svg" alt="대가의선택 로고" loading="lazy" />
						</router-link>
					</div>
					<DeskTopMainMenu />
				</div>
				<div class="quickMenu">
					<!-- // 구독 버튼 임시 주석 261023
					<button
						v-if="!tokenStore.isLogin || (tokenStore.isLogin && !getCheckAuthData?.success)"
						class="subscription_button"
						@click="router.push('/payment')"
					>
						구독
					</button>
					-->

					<CountryMenu />
					<SearchMenu />
					<NotificationMenu v-if="tokenStore.isLogin" />
					<MoreMenu />
					<InterestMenu v-if="Boolean(route.query.isInterestMenuOpen) && displayStore.isDesktop" />
					<div v-if="!tokenStore.isLogin" class="btn_login" @click="router.push('/auth/login')">
						<button>로그인</button>
					</div>
					<div v-if="tokenStore.isLogin" class="nickname">
						<span>{{ authStore.getMemberNickname }}</span>
						<span> 님</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 모바일용 헤더 -->
		<div v-if="!displayStore.isDesktop && !stickyTab" class="mobileHeader">
			<div class="c_inner">
				<div class="logoMenu">
					<!-- (Home일 때)좌측 -->
					<div v-if="path === '/home'" class="logoMenuList">
						<router-link to="/" class="logo">
							<img src="@/assets/img/bi/bi.svg" alt="대가의선택 로고" loading="lazy" />
						</router-link>
						<CountryMenu />
					</div>
					<!-- (Home이 아닐 때)좌측 -->
					<div v-else class="logoMenuList">
						<button
							v-if="
								path !== '/payment-complete' &&
								path !== '/sub/cancel-complete' &&
								path !== '/my/edit/account-delete-complete'
							"
							type="button"
							class="btn_back"
							@click="router.back()"
						>
							<img src="@/assets/img/common/arrow_prev.svg" alt="닫기" loading="lazy" />
						</button>
						<h2 class="pageName">{{ route.meta.title }}</h2>
					</div>
					<!-- 우측 -->
					<div v-if="route.path.split('/')[2] !== 'pw-change'" class="quickMenu">
						<!-- // 구독 버튼 임시 주석 261023
						<button
							v-if="!tokenStore.isLogin || (tokenStore.isLogin && !getCheckAuthData?.success)"
							class="subscription_button"
							@click="router.push('/payment')"
						>
							구독
						</button>
						-->

						<SearchMenu v-if="tokenStore.isLogin" />
						<NotificationMenu v-if="tokenStore.isLogin" />

						<router-link v-if="path !== '/home'" to="/" class="btn_home btn_toggle">
							<IconHome />
						</router-link>
						<MoreMenu />
						<div v-if="!tokenStore.isLogin" class="btn_login" @click="router.push('/auth/login')">
							<button>로그인</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition name="slide"
			><MobileMoreMenu v-if="Boolean(route.query.isMoreMenuOpen) && !displayStore.isDesktop"
		/></transition>
		<transition name="slide">
			<MobileNotification
				v-if="tokenStore.isLogin && Boolean(route.query.isNotificationMenuOpen) && !displayStore.isDesktop"
			/>
		</transition>
		<transition name="slide">
			<MobileSearch v-if="Boolean(route.query.isSearchMenuOpen) && !displayStore.isDesktop" />
		</transition>
		<transition name="slide">
			<MobileInterestMenu v-if="Boolean(route.query.isInterestMenuOpen) && !displayStore.isDesktop" />
		</transition>
	</header>
</template>

<script setup lang="ts">
// core
import { computed, onMounted, onUnmounted, onUpdated, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
import IconHome from '@/components/atom/icon/IconHome.vue';
import CountryMenu from '@/components/layout/header/CountryMenu/CountryMenu.vue';
// component
import DeskTopMainMenu from '@/components/layout/header/DeskTopMainMenu.vue';
import InterestMenu from '@/components/layout/header/InterestMenu/InterestMenu.vue';
import MobileInterestMenu from '@/components/layout/header/InterestMenu/MobileInterestMenu.vue';
import MobileMoreMenu from '@/components/layout/header/MoreMenu/MobileMoreMenu.vue';
import MoreMenu from '@/components/layout/header/MoreMenu/MoreMenu.vue';
import MobileNotification from '@/components/layout/header/NotificationMenu/MobileNotification.vue';
import NotificationMenu from '@/components/layout/header/NotificationMenu/NotificationMenu.vue';
import MobileSearch from '@/components/layout/header/SearchMenu/MobileSearch.vue';
import SearchMenu from '@/components/layout/header/SearchMenu/SearchMenu.vue';
import { useAuthStore } from '@/stores/auth';
// store
import { useDisplayStore } from '@/stores/display';
import { useTokenStore } from '@/stores/token';
import { closeMenuModal } from '@/utils/function/modalMenu';

// -----variable-----
const route = useRoute();
const router = useRouter();
const displayStore = useDisplayStore();
const tokenStore = useTokenStore();
const authStore = useAuthStore();

const isScrolled = ref(false); // 스크롤 여부
const lastScrollY = ref(0); //스크롤 Y 표시
const isDownScroll = ref(false); //스크롤 업다운 표시
const stickyTab = ref(false);

const path = computed(() => route.path.toLowerCase());
// -----function-----
// 구독 버튼 임시 주석 261023 - getCheckAuthData는 구독 버튼에서만 사용
const { refetch: refetchGetCheckAuth } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: false,
	}))
);

// 스크롤 여부
const setHeaderScrolled = () => {
	if (window.scrollY >= 10) {
		isScrolled.value = true;
	} else {
		isScrolled.value = false;
	}
};
// 스크롤 업/다운 여부
const setHeaderDownScrolled = () => {
	let currentScrollY = window.scrollY;
	if (lastScrollY.value < currentScrollY) {
		isDownScroll.value = true;
	} else {
		isDownScroll.value = false;
	}
	lastScrollY.value = currentScrollY;
	updateHeaderAndTabOnScroll();
};
// 스크롤 업/다운 시 헤더 유무
const updateHeaderAndTabOnScroll = () => {
	const headerEl = document.querySelector('.TopHeader');
	const tapEl = document.querySelector('.SubTabMenu');
	const bannerEl = document.querySelector('.c_page_banner')!;
	if (!bannerEl) return;

	const scrollY = window.scrollY;
	const bannerScrollWidth = bannerEl.scrollHeight;

	if (scrollY >= bannerScrollWidth - 60 && route.path.split('/')[1] === 'customer') {
		if (isDownScroll.value) {
			headerEl?.classList.add('enabled');
			tapEl?.classList.add('enabled');
		} else {
			headerEl?.classList.remove('enabled');
			tapEl?.classList.remove('enabled');
		}
	}
};

// -----composition-----
watch(
	() => displayStore.isDesktop,
	() => {
		closeMenuModal();
	}
);

watch(
	() => tokenStore.isLogin,
	() => {
		if (tokenStore.isLogin) {
			refetchGetCheckAuth();
		}
	},
	{
		immediate: true,
	}
);

onMounted(() => {
	document.addEventListener('scroll', setHeaderScrolled);
	document.addEventListener('scroll', setHeaderDownScrolled);
});

onUpdated(() => {
	const target = document.querySelector('.sticky_tab') as HTMLElement | null;

	window.addEventListener('scroll', () => {
		if (target) {
			const rect = target.getBoundingClientRect();
			if (rect.top <= (displayStore.isDesktop ? 74 : 64)) {
				stickyTab.value = true;
			} else {
				stickyTab.value = false;
			}
		} else {
			stickyTab.value = false;
		}
	});
});

onUnmounted(() => {
	document.removeEventListener('scroll', setHeaderScrolled);
	document.addEventListener('scroll', setHeaderDownScrolled);
});
</script>

<style scoped lang="scss">
.TopHeader {
	// 공통
	z-index: 90;
	position: fixed;
	top: 0;
	width: 100%;
	background-color: var(--color-bg);
	color: var(--color-base-white);
	transition: background-color var(--transition-slow);

	// 데스크탑 헤더
	.desktopHeader {
		box-shadow: 0.4rem 0.4rem 1rem 0rem rgba(0, 0, 0, 0.3);
		height: fit-content;
		.c_inner {
			--max-width: 1280px; // 최대 너비 지정
			display: flex;
			padding: 0rem;
			align-items: flex-start;
			justify-content: space-between;
			gap: var(--space-xx-large);
			user-select: none;
			padding-right: 2rem;
			padding-left: 2rem;
			.logoMenu {
				flex-shrink: 0;
				display: flex;
				align-items: center;
				height: var(--header-height);
				.logo {
					img {
						width: 4rem;
						height: 4rem;
					}
				}
			}
			.menuList {
				display: flex;
				gap: var(--space-xxxx-large);
			}
			.quickMenu {
				user-select: none;
				flex-shrink: 0;
				display: flex;
				align-items: center;
				height: var(--header-height);
				gap: var(--space-x-small);
				font-weight: var(--font-w-medium);
				font-size: var(--font-size-xxs);
				color: var(--color-base-gray-dark);
				white-space: nowrap;
				.quickMenu_item {
					display: flex;
					align-items: center;
					gap: var(--space-xxxxx-small);
					img {
						fill: var(--color-base-gray-dark);
						width: 1.1rem;
						height: 100%;
					}
				}
				.btn_login {
					margin-left: 0.8rem;
					button {
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-light);
						line-height: 1.9rem;
						background-color: var(--color-primary);
						padding: 0.4rem 0.8rem;
						border-radius: 0.4rem;
					}
				}
				.nickname {
					margin-left: 0.8rem;
					span {
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-semi-bold);
						line-height: 1.79rem;
					}
					span:nth-child(1) {
						color: var(--color-secondary-Blue);
					}
				}
			}
		}
	}

	// 모바일 헤더
	.mobileHeader {
		box-shadow: 0.4rem 0.4rem 1rem 0 rgba(0, 0, 0, 0.3);
		height: 6.4rem;
		height: fit-content;
		.c_inner {
			.logoMenu {
				height: var(--mobile-header-height);
				flex-shrink: 0;
				display: flex;

				align-items: center;
				justify-content: space-between;
				.logo img {
					width: 3.4rem;
				}
				.btn_back img {
					width: 2.6rem;
				}
				.pageName {
					font-size: var(--font-s-large);
					font-weight: var(--font-w-semi-bold);
					line-height: 1.5;
					white-space: nowrap;
				}
				.logoMenuList {
					display: flex;
					align-items: center;
					gap: 0.8rem;
				}
				.quickMenu {
					display: flex;
					align-items: center;
					gap: 0.8rem;
					.btn_search {
						position: relative;
						.search_box {
							position: absolute;
							z-index: 85;
							background-color: var(--color-bg);
							top: 7rem;
							right: 0rem;
							display: flex;
							flex-direction: column;
							width: 37.5rem;
							border-radius: var(--border-radius-small);
							align-items: flex-end;
							gap: 1rem;
							padding: 1.6rem 2rem;
						}
					}
					.btn_home {
						img {
							width: 2.4rem;
							margin-bottom: 0.2rem;
						}
					}
					.btn_login {
						button {
							font-size: var(--font-s-mid);
							font-weight: var(--font-w-light);
							line-height: 1.9rem;
							background-color: var(--color-primary);
							padding: 0.4rem 0.8rem;
							border-radius: 0.4rem;
						}
					}
				}
			}
		}
	}
}

.dimmed {
	position: fixed;
	background-color: rgba(45, 45, 45, 0.3);
	top: 0px;
	left: 0px;
	height: 100%;
	width: 100%;
	z-index: 80;
}
.slide-leave-to,
.slide-enter-from {
	transform: translateX(100%);
}
.slide-leave-from,
.slide-enter-to {
	transform: translateX(0);
}
.slide-enter-active {
	transition: transform 0.5s ease-in-out;
}
.slide-leave-active {
	transform: translateX(100%);
	transition: transform 0.5s ease-in-out;
}

.subscription_button {
	width: fit-content;
	padding: var(--space-x-small) var(--space-large);
	background-color: var(--color-primary);
	border-radius: var(--border-radius-small);

	color: var(--color-primary-contrast);
	font-size: var(--font-s-mid);
	font-weight: var(--font-w-semi-bold);
	line-height: 1;
	text-align: center;

	@media screen and (max-width: 1280px) {
		padding: var(--space-x-small) var(--space-mid);

		font-weight: var(--font-w-regular);
		font-size: var(--font-s-mid);
	}
}
</style>
